"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var formatNumberWithThousandSeparators = function formatNumberWithThousandSeparators(value) {
  return typeof value === 'number' ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '';
};

var _default = formatNumberWithThousandSeparators;
exports["default"] = _default;
//# sourceMappingURL=formatNumberWithThousandSeparators.js.map